var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/AWS/Database@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arch-Category_Customer-Enablement_64"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#8D94A1",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "database",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 8.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,17 C3.35825903,17 0,15.8113285 0,14.34375 L0,2.65625 C0,1.18933618 3.35825903,0 7.5,0 C11.6417415,0 15,1.18933618 15,2.65625 L15,14.34375 C15,15.8113285 11.6417415,17 7.5,17 Z M13.3928571,2.8564648 L13.3727677,2.8401956 C13.1953127,2.69044918 12.8404018,2.48359334 12.2611611,2.27906299 C11.1194198,1.87431681 9.43526745,1.59375 7.5,1.59375 C5.56473204,1.59375 3.88058015,1.87431681 2.73716467,2.27906299 C2.15926255,2.48359334 1.80502142,2.69044918 1.6262269,2.8401956 L1.60714184,2.8564648 L1.60714184,5.80058634 C2.05178465,6.01308614 2.66651681,6.27207011 3.44196337,6.46132833 C4.5770078,6.71035177 5.97656148,6.90625 7.49999898,6.90625 C9.02343648,6.90625 10.4229896,6.71035177 11.5580351,6.46132833 C12.3348202,6.27207011 12.947544,6.01308614 13.3928571,5.80058634 L13.3928571,2.8564648 L13.3928571,2.8564648 Z M13.3928561,7.55703145 C12.947544,7.73300761 12.4587045,7.88242167 11.9430797,8.00859365 C10.6640615,8.32070333 9.13392714,8.5 7.49999898,8.5 C5.8660703,8.5 4.33593648,8.32070333 3.05725336,8.00859365 C2.54229784,7.88242167 2.05312371,7.73300761 1.60714132,7.55703145 L1.60714132,10.0505863 C2.05178414,10.2630861 2.6665163,10.5220701 3.44196286,10.7113283 C4.57700729,10.9603518 5.97656097,11.15625 7.49999847,11.15625 C9.02343597,11.15625 10.4229891,10.9603518 11.5580346,10.7113283 C12.3348197,10.5220701 12.9475435,10.2630861 13.3928561,10.0505863 L13.3928561,7.55703145 L13.3928561,7.55703145 Z M1.62622639,14.1611328 C1.80502091,14.2806643 2.15892741,14.5164067 2.73716416,14.7222654 C3.88057964,15.1240234 5.56473153,15.40625 7.46986576,15.40625 C9.43526694,15.40625 11.1194193,15.1240234 12.2611606,14.7222654 C12.8404013,14.5164067 13.1953122,14.2806643 13.3727671,14.1611328 L13.3928566,14.1146486 L13.3928566,11.8070315 C12.9475445,11.9830076 12.4587051,12.1324217 11.9430803,12.2585942 C10.664062,12.5707033 9.13392765,12.75 7.46986576,12.75 C5.86607082,12.75 4.33593699,12.5707033 3.05725387,12.2585942 C2.54229835,12.1324217 2.05312422,11.9830076 1.57700811,11.8070315 L1.57700811,14.1146486 L1.6262269,14.1611328 L1.62622639,14.1611328 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.1b34432375f12e79a1938652a3674d9a.svg";
export { ForwardRef as ReactComponent };